import { Card } from "@/components/ui/card";
import { useAppDetails } from "@/contexts/AppDetailsContext";
import { useUserContext } from "@/contexts/userContext";
import { Button } from "react-day-picker";
import { useEffect } from "react";
import { useRouter } from "next/navigation";
import Loader from "@/components/Loader";

export default function CustomMainPage() {
  const { details } = useAppDetails();
  const router = useRouter();
  const { user, userLoading } = useUserContext();
  useEffect(() => {
    if (user) {
      router.push("/build");
    }
  }, [user]);
  if (userLoading || user) {
    return (
      <div className="w-full h-[100vh] flex items-center justify-center">
        <Loader />
      </div>
    );
  }
  return (
    <div className="min-h-screen flex items-center justify-center  px-6">
      <Card className="max-w-md p-8 rounded-3xl text-center space-y-5">
        <img
          src={details?.brokerLogo}
          className="md:max-h-[30px] xs:max-h-[25px] max-h-[25px] sm:max-w-[300px]"
          alt=""
        />
        <h2 className="text-xl font-semibold ">Login Required</h2>
        <p className=" text-muted-foreground">
          Login to this app from your broker portal
        </p>

        <p className="text-xs text-gray-500">
          Need help? Contact {details?.supportEmail}
        </p>
      </Card>
    </div>
  );
}
